import React, { Component } from "react";
import data from "../common/patientData.json";
import { patientSchema } from "../../schema/token";
import TechnicianCard from "./TechnicianCard";
import TechnicianCardsDisplay from "./TechnicianCardsDisplay";

class Technician extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldData: [],
    };
  }

  handleChange(event) {
    let fields = this.state.fieldData;
    fields.map((field, key) => {
      if (event.name === field.name) {
        this.state.fieldData[key]["valid"] = true;
        this.state.fieldData[key]["value"] = event.value;
        this.state.fieldData[key]["errors"] = [];
      }
    });
  }

  displayDivs() {
    const item = {
      doctorname: "Anil Kumar",
      doctorstatus: "Cardiologist",
      roomnumber: "12",
    };
    return (
      <div className="col-3">
        <TechnicianCard item={item} />
        <TechnicianCardsDisplay
          data={data}
          patientSchema={patientSchema}
          handleChange={this.handleChange.bind(this)}
        />
      </div>
    );
  }

  render() {
    return <div className="row technician">{this.displayDivs()}</div>;
  }
}
export default Technician;
